export default __webpack_public_path__ + "static/media/textbox_left_next_button.f05ed3f3.png";